<template>
    <c-collapse :visible="show">
        <slot/>
    </c-collapse>
</template>
<script setup>
import {CCollapse} from "@coreui/vue/dist/esm/components/collapse/index.js";

defineProps(['show']);
</script>
